$(function () {
  const positionSelect = document.querySelector('select[ref="position"]')
  const bankSelect = document.querySelector('select[ref="bank"]')
  const bankNameInput = document.querySelector('input[ref="bank-name"]')

  const lawyerPositionId = $(positionSelect).data('lawyer-id').toString()
  const paymentInformationEl = document.querySelector('#reg-payment-information')
  const bankNameRowEl = document.querySelector('tr[ref="bank-name-row"]')

  //
  // helpers
  //

  const showHidePaymentInformation = function () {
    const position = positionSelect.value

    if (position === lawyerPositionId) {
      $(paymentInformationEl).hide()
    } else {
      $(paymentInformationEl).show()
    }
  }

  const showHideBankName = function () {
    if (bankSelect.value === '-1') {
      $(bankNameRowEl).show()
    } else {
      $(bankNameRowEl).hide()
      bankNameInput.value = '' // clear bank name
    }
  }

  //
  // initialization actions
  //

  positionSelect.addEventListener('change', function (e) {
    showHidePaymentInformation()
  })

  showHidePaymentInformation()

  bankSelect.addEventListener('change', function (e) {
    showHideBankName()
  })

  showHideBankName()
})
